var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"wrapper",staticClass:"v-loader-wrapper",class:_vm.wrapperClasses},[_c('span',{directives:[{name:"icon",rawName:"v-icon:tw-spin",arg:"tw-spin"}],ref:"spinner",staticClass:"v-loader"})])}
var staticRenderFns = []

export { render, staticRenderFns }